import { render, staticRenderFns } from "./ModalSelectOrder.vue?vue&type=template&id=bc4199b0&scoped=true"
import script from "./ModalSelectOrder.vue?vue&type=script&lang=js"
export * from "./ModalSelectOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4199b0",
  null
  
)

export default component.exports